module.exports = __webpack_public_path__ + "static/img/293_TO8_2275.4c57dd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/293_TO8_2275.jpg
// module id = zocI
// module chunks = 0